import { render, staticRenderFns } from "./CreateProject.vue?vue&type=template&id=8e7c5ede&scoped=true&"
import script from "./CreateProject.vue?vue&type=script&lang=js&"
export * from "./CreateProject.vue?vue&type=script&lang=js&"
import style0 from "./CreateProject.vue?vue&type=style&index=0&id=8e7c5ede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7c5ede",
  null
  
)

export default component.exports